import { render, staticRenderFns } from "./BarbersBlock.vue?vue&type=template&id=77893b81&"
import script from "./BarbersBlock.vue?vue&type=script&lang=js&"
export * from "./BarbersBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports